import { ErrorLocationType } from "@/utilities/enums/Enums";
import {useErrorStore} from "@/stores/ErrorStore";

export default function hideError ({next}:any){
    const errorStore = useErrorStore();

    if (errorStore.location !== ErrorLocationType.none) errorStore.location = ErrorLocationType.none;

    return next();
}
